"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterManagerV1 = void 0;
const SESSION_STORAGE_KEY = 'parameter-manager-storage';
class ParameterManagerV1 {
    constructor(whitelist) {
        this.whitelist = whitelist;
        this.params = {};
        const isInBrowser = this.isInBrowser();
        // read from session storage
        const storedEntries = JSON.parse((isInBrowser && sessionStorage.getItem(SESSION_STORAGE_KEY)) || '{}');
        // remove not whitelisted entries
        for (const [key, value] of Object.entries(storedEntries)) {
            if (whitelist.indexOf(key) >= 0) {
                this.params[key] = value;
            }
        }
        // get search params ...
        const searchParams = new URLSearchParams(isInBrowser ? window.location.search : '');
        // ... and remove not whitelisted entries
        const urlWhitelistedEntries = {};
        Array.from(searchParams.entries()).forEach((entry) => {
            const key = entry[0];
            const value = entry[1];
            if (whitelist.indexOf(key) >= 0) {
                urlWhitelistedEntries[key] = value;
            }
        });
        // if there are new whitelisted params replace old ones
        if (Object.keys(urlWhitelistedEntries).length > 0) {
            // use new parameters
            this.params = urlWhitelistedEntries;
            // update session storage
            isInBrowser &&
                sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(this.params));
        }
    }
    getParams(keys) {
        let keyValues;
        if (keys === undefined) {
            keyValues = Object.keys(this.params);
        }
        else if (typeof keys === 'string') {
            keyValues = [keys];
        }
        else {
            keyValues = keys;
        }
        return keyValues
            .filter((key) => this.params[key])
            .reduce((result, key) => {
            result[key] = this.params[key];
            return result;
        }, {});
    }
    isInBrowser() {
        return Boolean(typeof window !== 'undefined' &&
            typeof window.sessionStorage !== 'undefined');
    }
}
exports.ParameterManagerV1 = ParameterManagerV1;
//# sourceMappingURL=v1.js.map